import styled from 'styled-components'
import { Panel } from 'ui/components/Panel'

export const TablePanel = styled(Panel)`
  margin-bottom: 70px;
`
